import { render, staticRenderFns } from "./detail-jishen.vue?vue&type=template&id=d98d0282&scoped=true"
import script from "./detail-jishen.vue?vue&type=script&lang=js"
export * from "./detail-jishen.vue?vue&type=script&lang=js"
import style0 from "./detail-jishen.vue?vue&type=style&index=0&id=d98d0282&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98d0282",
  null
  
)

export default component.exports